import React from "react";
import "../CSS/Footer.css";
import { Link } from "react-router-dom";
import insta1 from "../../assets/temporary/gray.png";
import insta2 from "../../assets/temporary/gray.png";
import insta3 from "../../assets/temporary/gray.png";
import insta4 from "../../assets/temporary/gray.png";
import footerBanner from "../../assets/footer/footerImage.png"; // ← adjust path/name as needed
import FooterLink from "./FooterLink";

const Footer = () => (
  <footer className="site-footer">
    <div className="footer-container">

      <div className="footer-top">
        {/* Brand */}
        <div className="footer-brand-section">
          <h1 className="footer-description">NeridTech</h1>
          <p className="footer-description">
          Delivering high-performance ASIC design and verification solutions with precision, speed, and reliability.
          </p>
          <p className="footer-contact">
            CONTACT US 24/7<br/>
            <span className="footer-phone">+381 64 468 9658</span>
          </p>
        </div>

        {/* Links + Banner */}
        <div className="footer-links-group">

          {/* Left: Services + Technologies */}
          <div className="footer-links-left">
            <div className="footer-column">
              <h4>Our Services</h4>
              <ul>
                <li><FooterLink to="/services/asic-design"><b>ASIC Design</b></FooterLink></li>
                <li><FooterLink to="/services/asic-design/front-end-rtl-design">Front-End RTL Design</FooterLink></li>
                <li><FooterLink to="/services/asic-design/ip-development">IP Development</FooterLink></li>
                <li><FooterLink to="/services/asic-design/soc-integration">SoC Integrations</FooterLink></li>
                <li><FooterLink to="/services/asic-design/low-power-design">Low-Power Design</FooterLink></li>
                <li><FooterLink to="/services/asic-verification"><b>ASIC Verification</b></FooterLink></li>
                <li><FooterLink to="/services/asic-verification/uvm-based-testbenches">UVM-based Testbenches</FooterLink></li>
                <li><FooterLink to="/services/asic-verification/functional-verification">Functional Verification</FooterLink></li>
                <li><FooterLink to="/services/asic-verification/formal-verification">Formal Verification</FooterLink></li>
                <li><FooterLink to="/services/asic-verification/regression-testing-and-coverage">Regression Testing & Coverage</FooterLink></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Technologies</h4>
              <ul>
                <li><FooterLink to="/technologies/tools-and-languages"><b>Tools & Languages</b></FooterLink></li>
                <li><FooterLink to="/technologies/tools-and-languages/systemverilog">SystemVerilog</FooterLink></li>
                <li><FooterLink to="/technologies/tools-and-languages/vhdl">VHDL</FooterLink></li>
                <li><FooterLink to="/technologies/tools-and-languages/uvm">UVM</FooterLink></li>
                <li><FooterLink to="/technologies/tools-and-languages/formal-verification">Formal Verification</FooterLink></li>
                <li><FooterLink to="/technologies/methodologies"><b>Methodologies</b></FooterLink></li>
                <li><FooterLink to="/technologies/methodologies/agile-hardware-development">Agile Hardware Dev</FooterLink></li>
                <li><FooterLink to="/technologies/methodologies/ci-cd">CI/CD</FooterLink></li>
                <li><FooterLink to="/technologies/platforms"><b>Emulators</b></FooterLink></li>
              </ul>
            </div>
          </div>

          {/* Right: Careers, About Us, Contact + Banner */}
          <div className="footer-links-right">
            <div className="footer-column">
              <h4>Careers</h4>
              <ul>
                <li><FooterLink to="/careers/job-openings">Job Openings</FooterLink></li>
                <li><FooterLink to="/careers/application-submission-form">Application</FooterLink></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>About Us</h4>
              <ul>
                <li><FooterLink to="/about-us">Our team</FooterLink></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Contact</h4>
              <ul>
                <li><FooterLink to="/contact">Contact Us</FooterLink></li>
              </ul>
            </div>

            {/* Banner under those three */}
            <div className="footer-extra-image">
              <img src={footerBanner} alt="NeridTech banner"/>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <div className="footer-social-icons">
          <a href="#facebook" aria-label="Facebook"><i className="fab fa-facebook-f"/></a>
          <a href="#twitter"  aria-label="Twitter"><i className="fab fa-twitter"/></a>
          <a href="#linkedin" aria-label="LinkedIn"><i className="fab fa-linkedin-in"/></a>
          <a href="#instagram"aria-label="Instagram"><i className="fab fa-instagram"/></a>
        </div>
        <p className="footer-copyright">
          © 2025 by NeridTech. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;